import script from "./TranscriptBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./TranscriptBlock.vue?vue&type=script&setup=true&lang=ts"

import "./TranscriptBlock.vue?vue&type=style&index=0&id=654f3a76&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-654f3a76"]])

export default __exports__